import React from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";
import { Role } from "../../types/General";
import Panigation from "../../components/Panigation";
import { showError, showToast } from "../../constants/toasts";
import { useUpdateRoleMutation } from "../../services/role";

interface RolesListProps {
  data: Role[];
  isLoading: boolean;
  totalCount: number;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  onSearch: (search: string) => void;
  onDelete: (id: number) => void;
}

const RolesList = ({
  data,
  isLoading,
  totalCount,
  page,
  setPage,
  onSearch,
  onDelete,
}: RolesListProps) => {
  const navigate = useNavigate();
  const [UpdateStatus] = useUpdateRoleMutation();

  const handleStatusUpdate = async (id: number, status: boolean) => {
    const body = {
      is_active: status,
      id: id,
    };

    try {
      const response = await UpdateStatus({
        body,
      }).unwrap();
      if (response?.status === 200) {
        showToast(`Role ${!status ? "deactivated" : "activated"} successfully`);
      } else {
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };
  return (
    <div>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow hover>
              <TableCell>Role Name</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No roles found
                </TableCell>
              </TableRow>
            ) : (
              data.map((role) => (
                <TableRow hover key={role?.id}>
                  <TableCell>
                    <div
                      className="user_block click_action"
                      onClick={() =>
                        navigate(`/manage-subadmin/roles/detail/${role?.id}`)
                      }
                    >
                      <p>
                        <b>{role.role_name}</b>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>
                    {role.createdAt
                      ? new Date(role?.createdAt).toLocaleDateString("en-US", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })
                      : "N/A"}
                  </TableCell>
                  <TableCell>
                    <SwitchToggle
                      defaultChecked={role?.is_active ?? false}
                      onChange={(checked) =>
                        handleStatusUpdate(role?.id, checked)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <Box>
                        <IconButton
                          onClick={() =>
                            navigate(
                              `/manage-subadmin/roles/detail/${role?.id}`
                            )
                          }
                        >
                          <img src="/static/images/eye_icon.svg" alt="view" />
                        </IconButton>
                      </Box>
                      <Box>
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-subadmin/roles/edit/${role?.id}`)
                          }
                        >
                          <img src="/static/images/edit2_icon.svg" alt="edit" />
                        </IconButton>
                      </Box>
                      <Box>
                        <IconButton onClick={() => onDelete(role?.id)}>
                          <img
                            src="/static/images/trash2_icon.svg"
                            alt="delete"
                          />
                        </IconButton>
                      </Box>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalCount > 0 && (
        <div className="pagination_wrapper">
          <Panigation
            module={data}
            totalCount={totalCount}
            page={page}
            setPage={setPage}
            onPageChange={setPage}
            totalPages={Math.ceil(totalCount / 10)}
          />
        </div>
      )}
    </div>
  );
};

export default RolesList;
